// extracted by mini-css-extract-plugin
module.exports = {"button":"_24LNKAhoJZ5vNlbgyxqjQx"};